module.exports = __webpack_public_path__ + "static/twitterCardImage-d646dcb974cd888faa87cfd6057fb0c4.jpeg";